const arr = ['localhost', 'frontend'];
export const ADMIN_APP_KEY = 'auth-service';
export const DEVMODE = arr.includes(window.location.hostname);
export const BACKEND_BASE_URL = DEVMODE ? 'http://localhost:8017/graphql' : 'https://auth-service-api.seenthis.co/graphql';
export const FRONTEND_BASE_URL = DEVMODE ? 'http://localhost:8069' : 'https://auth-service.seenthis.co';
